export interface CompanyEvent {
  id: string;
  name: string;
  start: string | null;
  end: string | null;
  location: string | null;
  businessUnitRaw: string | null;
  links: string[] | null;
}
/** A blog or LinkedIn post; `image` is a proxied `images/<id>` path. */
export interface ContentPost {
  title: string;
  url: string;
  published: string;
  description?: string;
  image?: string;
}
/** The News & updates content served by the home-content backend plugin. */
export interface HomeContent {
  blogUpdated?: string;
  socialUpdated?: string;
  eventsUpdated?: string;
  posts: ContentPost[];
  socialPosts: ContentPost[];
  events: CompanyEvent[];
}
export function localDateKey(date = new Date()): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    '0',
  )}-${String(date.getDate()).padStart(2, '0')}`;
}
export function upcomingEvents(events: CompanyEvent[], today = localDateKey()) {
  return events
    .filter(event => event.start && (event.end || event.start) >= today)
    .sort((a, b) => a.start!.localeCompare(b.start!))
    .slice(0, 3);
}
// The reader's own locale, like the rest of Backstage.
export function displayDate(value: string): string {
  return new Date(`${value.slice(0, 10)}T12:00:00`).toLocaleDateString(
    undefined,
    { day: 'numeric', month: 'short', year: 'numeric' },
  );
}
/** A same-site path such as "/docs/…"; anything else (including "//host") is dropped. */
export function internalPath(value?: string): string | undefined {
  return value && /^\/(?!\/)/.test(value) ? value : undefined;
}

export function safeExternalUrl(value?: string): string | undefined {
  try {
    const url = new URL(value || '');
    return ['https:', 'http:'].includes(url.protocol) ? url.href : undefined;
  } catch {
    return undefined;
  }
}
